export const CONTENTS_TYPE_CD = {
  MALL_LINKAGE_GUIDE: 'CTC100',
  MAIN_CONTENTS: 'CTC200',
};
